import { createSelector } from "reselect";
import { GROUP_ID } from "../../constants/QueryString.constants.js";
const getSearchParam = (state, param) => param;
const getRouteLocationSearch = (state) => {
  var _a, _b;
  return (_b = (_a = state == null ? void 0 : state.routeState) == null ? void 0 : _a.routeLocation) == null ? void 0 : _b.search;
};
const getRouteLocationPathname = (state) => {
  var _a, _b;
  return (_b = (_a = state == null ? void 0 : state.routeState) == null ? void 0 : _a.routeLocation) == null ? void 0 : _b.pathname;
};
const getRouteLocationSearchParam = createSelector(
  getRouteLocationSearch,
  getSearchParam,
  (search, param) => {
    const searchParams = new URLSearchParams(search);
    const groupId = searchParams.get(param);
    return !!(groupId == null ? void 0 : groupId.length) ? groupId : null;
  }
);
const getRouteLocationSearchGroup = (state) => getRouteLocationSearchParam(state, GROUP_ID);
export {
  getRouteLocationPathname,
  getRouteLocationSearch,
  getRouteLocationSearchGroup,
  getRouteLocationSearchParam
};
//# sourceMappingURL=RouteUpdate.selectors.js.map
